import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserInfo } from "../interfaces/roles";
import { IUserInfoState } from "../interfaces/slices";

const initialState: IUserInfoState = {
    lanid: '',
    firstName: '',
    lastName: '',
    profilePicture: '',
    roles: {
        maker: false,
        checker: false,
        previewer: false,
    }
}

export const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        setLanId: (state, action: PayloadAction<string>) => {
            state.lanid = action.payload;
        },
        addUserInfo: (state, action: PayloadAction<IUserInfo>) => {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.profilePicture = action.payload.profilePic;
            state.roles.maker = action.payload.role.maker;
            state.roles.checker = action.payload.role.checker;
            state.roles.previewer = action.payload.role.previewer;
        },
    },
})

export const { addUserInfo, setLanId } = userInfoSlice.actions
export default userInfoSlice.reducer;